<template>
  <div class="container pdf-print-care">
    <ErrorsMessages :errors="errors" />
    <div class="row">
      <div v-show="errors.length == 0" class="pl-0 pt-0 col-md-12">
        <b-overlay :show="loading" opacity="0.99">
          <table class="table">
            <thead>
              <tr>
                <td>
                  <div class="header-space">
                    <table class="table">
                      <tr>
                        <td>
                          <div class="d-flex align-items-center">
                            <img
                              v-if="rest_home_logo_url"
                              class="rest_home_logo_url"
                              :src="rest_home_logo_url"
                            />
                            <div v-if="!rest_home_logo_url" class="ml-1">
                              <strong class="text-uppercase">{{
                                rest_home_name
                              }}</strong>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img
                              v-if="care.resident_photo_url"
                              class="resident_photo_url"
                              :src="care.resident_photo_url"
                            />
                            <img
                              v-if="!care.resident_photo_url"
                              class="resident_photo_url"
                              :src="require('../../../../assets/user.png')"
                            />
                            <div class="ml-1">
                              <p class="m-0">
                                <strong>
                                  {{ care.resident_name }}
                                </strong>
                              </p>
                              <p class="m-0">
                                <span class="text-muted"
                                  >Data de nascimento:
                                </span>
                                {{
                                  formatDate(care.resident_date_of_birth, false)
                                }}
                                -
                                {{ getAge(care.resident_date_of_birth) }}
                                anos
                              </p>
                              <p class="m-0">
                                <span class="text-muted"
                                  >Data de admissão:
                                </span>
                                {{
                                  formatDate(
                                    care.resident_date_of_reception,
                                    false
                                  )
                                }}
                              </p>
                              <p class="m-0" v-if="care.resident_bed_id">
                                <span class="text-muted">Leito: </span>
                                <span class="text-muted">Nº: </span>
                                {{ care.resident_bed_number }}
                                ,
                                <span class="text-muted">Andar: </span>
                                {{ care.resident_bed_walk }}
                                ,
                                <span class="text-muted">ALA/Setor: </span>
                                {{ care.resident_bed_ward_or_sector }}
                                ,
                                <span class="text-muted">Quarto: </span>
                                {{ care.resident_bed_bedroom }}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-right">
                            <img class="logo" :src="logo" />
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p class="text-muted text-center m-0">
                    Cuidados - Anotação de Enfermagem -
                    {{ formatDate(care.created_at, false) }}
                  </p>
                  <p class="m-0 text-center"></p>
                </td>
              </tr>
              <tr>
                <td v-if="shift_change_init">
                  <strong>Assumo</strong> o plantão, cliente
                  {{ care.resident_name }} no(a)
                  <span
                    v-for="(item, key) in shift_change"
                    :key="`${key}-${generateId()}`"
                    v-show="item.beginning_or_end == 'INICIO'"
                    >{{ item.place }}, {{ item.response }};</span
                  >
                </td>
              </tr>
              <tr>
                <td v-if="feeding_care.length > 0">
                  <strong>Alimentação:</strong>
                  <span
                    v-for="(item, key) in feeding_care"
                    :key="`${key}-${generateId()}`"
                  >
                    {{ item.feeding_care_name }}: {{ item.response }} ({{
                      formatDate(item.created_at)
                    }});
                  </span>
                </td>
              </tr>
              <tr>
                <td v-if="bath.length > 0">
                  <strong>Banho: </strong>
                  <span
                    v-for="(item, key) in bath"
                    :key="`${key}-${generateId()}`"
                    >Realizado o banho de {{ item.bath_type }} pela
                    {{ item.shift }} ({{ formatDate(item.created_at) }});</span
                  >
                </td>
              </tr>
              <tr>
                <td v-if="care.annotation">
                  <strong>Observação:</strong> {{ care.annotation }}
                </td>
              </tr>
              <tr>
                <td v-if="shift_change_end">
                  <strong>Encerro</strong> o plantão, cliente
                  {{ care.resident_name }} no(a)
                  <span
                    v-for="(item, key) in shift_change"
                    :key="`${key}-${generateId()}`"
                    v-show="item.beginning_or_end == 'FIM'"
                    >{{ item.place }}, {{ item.response }};</span
                  >
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  (Assinatura eletrônica)
                  <span class="signature-coren">
                    {{
                      professionalClassCouncilValue({
                        id: care.user_professional_class_council_id,
                        name: care.user_name,
                        profile: care.user_profile_name,
                        cpf: care.user_cpf,
                        office: care.user_office,
                        value: care.user_professional_class_council_value,
                      })
                    }}
                  </span>
                  <span v-if="care.certificate"> - Certificado: </span>
                  {{ care.certificate ? care.certificate : "" }}
                  <span> - {{ formatDate(care.updated_at) }} </span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-overlay>
      </div>
      <div class="pl-0 pt-0 col-md-12 text-right">
        <v-btn @click="handlePrint" class="v-warning">IMPRIMIR</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import {
  generateId,
  formatDate,
  formatPrice,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import { getAge } from "../../../../lib/getAgeByDate";

import routes from "../../../../routes";

import { userData } from "../../../../lib/functions";

export default {
  name: "PrintOutCare",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      errors: [],
      care: {},
      rest_home_id: "",
      bath: [],
      shift_change: [],
      shift_change_init: false,
      shift_change_end: false,
      feeding_care: [],
      rest_home_name: null,
      rest_home_logo_url: null,
      logo: null,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    generateId,
    formatDate,
    formatPrice,
    professionalClassCouncilValue,
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    async retrieve() {
      const { id } = routes.history.current.params;

      const { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.id = id;
      this.rest_home_id = user.rest_home_id;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        let response = await api.get("/offline/residents/annotations");
        let { error, errors, residents } = response.data;
        if (error) {
          this.errors = errors;
          return;
        }

        let annotations = [];
        for (let resident of residents) {
          annotations.push(...resident.annotations);
        }

        let care = annotations.filter((item) => item.id == id);

        if (care[0]) {
          this.care = care[0];

          let { care_has_bath, care_has_feeding_care, care_has_shift_change } =
            care[0];

          this.bath = care_has_bath;
          this.shift_change = care_has_shift_change;
          this.feeding_care = care_has_feeding_care;

          this.shift_change_init = false;
          this.shift_change_end = false;

          if (care_has_shift_change.length > 0) {
            care_has_shift_change.forEach((item) => {
              if (item.beginning_or_end == "INICIO") {
                this.shift_change_init = item;
              }

              if (item.beginning_or_end == "FIM") {
                this.shift_change_end = item;
              }
            });
          }
        }
        this.loading = false;
      } else {
        await this.get();
      }
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/care/print", {
          params,
        });

        const { error, errors, care, bath, shift_change, feeding_care } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.care = care;

          this.bath = bath;
          this.shift_change = shift_change;
          this.feeding_care = feeding_care;

          this.shift_change_init = false;
          this.shift_change_end = false;

          if (shift_change.length > 0) {
            shift_change.forEach((item) => {
              if (item.beginning_or_end == "INICIO") {
                this.shift_change_init = item;
              }

              if (item.beginning_or_end == "FIM") {
                this.shift_change_end = item;
              }
            });
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
.pdf-print-care .header,
.pdf-print-care .header-space {
  height: 150px;
}
.pdf-print-care .header {
  position: fixed;
  top: 0;
}
.pdf-print-care .medicine {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.pdf-print-care .name {
  font-weight: bold;
}
.pdf-print-care .active-ingredient {
  font-size: 12px;
}
.pdf-print-care .via {
  font-weight: bold;
  font-size: 12px;
}
.pdf-print-care .user {
  transform: rotate(290deg) !important;
  font-size: 8px;
  width: 20px;
}
.pdf-print-care .checked-icon {
  width: 15px;
}
.pdf-print-care .logo {
  height: 50px;
  object-fit: contain;
}
.pdf-print-care .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.pdf-print-care .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  .pdf-print-care button {
    display: none;
  }
  .pdf-print-care li {
    list-style-type: none;
  }
}
</style>
